import React from 'react'
import { graphql } from 'gatsby'
import { Link } from 'gatsby'

import Layout from '../components/layout'
import IconMissingPage from '../images/404.svg'

export default function NotFoundPage({ data }) {

  return (
    <>
      <Layout
        isFrontPage={false}
        pageTitle={data.site.siteMetadata.title}
        description={data.site.siteMetadata.slogan}
        slogan={data.site.siteMetadata.slogan}
        siteTitle={data.site.siteMetadata.title}
      >

        <section className="not-found section">
          <div className="grid grid--vertically-centered">
            <div className="grid__item grid__item--tablet-up-half grid__item--desktop-up-3 grid__item--desktop-up-offset-3">
              <div className="not-found__inner">
                <div className="section-heading section-heading--left section-heading--tight">
                  <h3 className="block__heading heading--3">The page youʼre looking for canʼt be found</h3>
                  <p className="block__content">Make sure the web address is correct and try again. View <Link to="/">full example list</Link>.</p>
                </div>
              </div>
            </div>

            <div className="grid__item grid__item--tablet-up-half grid__item--desktop-up-4">
              <div className="not-found__inner">
                <svg>
                  <use xlinkHref={`#${IconMissingPage.id}`} />
                </svg>
              </div>
            </div>
          </div>
        </section>
      </Layout>
    </>
  )
}

export const pageQuery = graphql`
  {
    site {
      siteMetadata {
        title
        slogan
      }
    }
  }
`